import { useGetConfig } from "@fp/admin-api-client/config/config.client";
import { GoogleMapsProvider } from "@fp/ui/providers/google-maps-provider";
import type { ReactNode } from "react";

export function GoogleMapsConfigProvider({ children }: { children: ReactNode }) {
  const { data } = useGetConfig();
  const googleMaps = data?.data.googleMaps;

  if (!googleMaps?.apiKey) {
    return <>{children}</>;
  }

  return (
    <GoogleMapsProvider apiKey={googleMaps.apiKey} mapId={googleMaps.mapId}>
      {children}
    </GoogleMapsProvider>
  );
}